<div
  class="sidebar"
  [ngClass]="{
    'sidebar--regular': sidebarState() === 'regular',
    'sidebar--narrow': sidebarState() === 'narrow',
  }">
  <a routerLink="/" class="sidebar__logo" aria-label="CareHub Logo">
    <img src="/carehub_logo.svg" alt="CareHub Logo" class="sidebar__logo-icon" />
    @if (sidebarState() === 'regular') {
      <span class="sidebar__logo-text">
        <span>CareHub</span>
      </span>
    }
  </a>

  <ul class="sidebar-nav">
    @for (module of menuItems; track module) {
      <li class="sidebar-nav__title">{{ module.label }}</li>

      @for (item of module.items; track item) {
        <li
          class="sidebar-nav__item"
          [routerLink]="item.routerLink"
          routerLinkActive="sidebar-nav__item--active"
          (click)="item.expanded = !item.expanded; $event.stopPropagation()"
          tabindex="0"
          role="button">
          <a class="sidebar-nav__item-link">
            <i [class]="item.icon + ' sidebar-nav__item-icon'"></i>
            <span class="sidebar-nav__item-label">
              {{ item.label }}
              @if (sidebarState() === 'regular' && item.items) {
                <i
                  class="sidebar-nav__item-expand-icon"
                  [class]="item.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
              }
            </span>
          </a>
          @if (sidebarState() === 'regular' && item.items && item.expanded) {
            <ul class="sidebar-nav__sub-items">
              @for (subItem of item.items; track subItem) {
                <li
                  class="sidebar-nav__sub-item"
                  [routerLink]="subItem.routerLink"
                  routerLinkActive="sidebar-nav__sub-item--active"
                  (click)="$event.stopPropagation()"
                  tabindex="0"
                  role="button">
                  <a class="sidebar-nav__sub-item-link">
                    <span class="sidebar-nav__sub-item-label">{{ subItem.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
          @if (sidebarState() === 'narrow' && item.items) {
            <ul class="sidebar-nav__sub-items">
              @for (subItem of item.items; track subItem) {
                <li
                  class="sidebar-nav__sub-item"
                  [routerLink]="subItem.routerLink"
                  routerLinkActive="sidebar-nav__sub-item--active"
                  (click)="$event.stopPropagation()"
                  tabindex="0"
                  role="button">
                  <a class="sidebar-nav__sub-item-link">
                    <span class="sidebar-nav__sub-item-label">{{ subItem.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    }
  </ul>
</div>
